import { Component, OnInit } from '@angular/core';
import { User } from '../../model/user';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { DBService } from '../../services/db.service';
import { Employee } from '../../model/employee';
import { importLog } from '../../model/importLog';
import { Activity, ActivityStatus } from '../../model/activity';
import { Document } from '../../model/document';
import { Company } from '../../model/company';
import { Bidding } from '../../model/bidding';
import { HttpClient } from '@angular/common/http';
import { array } from '@amcharts/amcharts4/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [DBService]
})
export class HeaderComponent implements OnInit {

  user: User;
  isHome: boolean;
  isUsers: boolean;
  isCompany: boolean;
  isDocument: boolean;
  isDocumentType: boolean;
  isSegment: boolean;
  isBidding: boolean;
  isActivities: boolean;
  isActivityReport: boolean;
  isBiddingReport: boolean;
  isPartners: boolean;
  isPartnerReport: boolean;
  isCustomerReport: boolean;
  isCompanyReport: boolean;
  isIndications: boolean;
  isFunnelReport: boolean;
  isUpReport: boolean;
  isDownReport: boolean;
  employee: Employee;
  
  allCompanies: Company[];
  endingBiddings: Bidding[];
  companies: Company[];
  employees: Employee[];
  imports: importLog[];
  companyEmployeeMail: any;
  companyEmployeeName: any;
  showResult: boolean;
  timeToImport: boolean;

  isAdminUser: boolean;
  isCompanyAdminUser: boolean;

  searchText: string;

  ImportaLicitacoes = 'https://us-central1-i-ganhei.cloudfunctions.net/ImportaLicitacoes';
  VencimentoLicitacao = 'https://us-central1-i-ganhei.cloudfunctions.net/VencimentoLicitacao';

  constructor(private http: HttpClient, private router: Router, private authService: AuthenticationService, private dbService: DBService) {

    this.user = this.authService.getUser();
    this.employee = new Employee();

    this.searchText = '';

    this.updateLabels(router.url);

    router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        this.updateLabels(event.url);
        setTimeout(() => {
          this.user = this.authService.getUser();
          this.isCompanyAdminUser = this.authService.isCustomerAdmin();
          this.isAdminUser = this.authService.isAdmin();
        }, 500);
      });
  }

  private updateLabels(url: string) {
    this.isCompany = url.includes('empresas');
    this.isUsers = url.includes('usuarios');
    this.isSegment = url.includes('segmentos');
    this.isDocumentType = url.includes('categorias-documentos');
    this.isActivityReport = url.includes('relatorio-de-atividades');
    this.isBiddingReport = url.includes('relatorio-de-licitacoes');
    this.isPartnerReport = url.includes('relatorio-de-parceiros');
    this.isCustomerReport = url.includes('relatorio-de-clientes');
    this.isCompanyReport = url.includes('relatorio-de-empresa');
    this.isIndications = url.includes('indicacoes');
    this.isPartners = url.includes('parceiros') && !this.isPartnerReport;
    this.isBidding = url.includes('licitacoes') && !this.isBiddingReport;
    this.isActivities = url.includes('atividades') && !this.isActivityReport;
    this.isDocument = url.includes('documentos') && !this.isDocumentType;
    this.isFunnelReport = url.includes('relatorio-de-funil-de-vendas');
    this.isUpReport = url.includes('relatorios-licitacoes-vencidas');
    this.isDownReport = url.includes('relatorios-licitacoes-perdidas');
    this.isHome =
      !this.isCompany &&
      !this.isUsers &&
      !this.isDocument &&
      !this.isSegment &&
      !this.isDocumentType &&
      !this.isBidding &&
      !this.isActivities &&
      !this.isBiddingReport &&
      !this.isActivityReport &&
      !this.isPartners &&
      !this.isPartnerReport &&
      !this.isCustomerReport &&
      !this.isCompanyReport &&
      !this.isIndications &&
      !this.isFunnelReport &&
      !this.isUpReport &&
      !this.isDownReport;
  }

  goTo(page) {
    this.router.navigate([page]);
  }

  goToEditProfile() {
    this.goTo(`/usuarios/edit/${this.user.uid}`);
  }

  ngOnInit() {
    this.loadCompanies();
  }

  private loadCompanies() {
    this.showResult = false;

    this.dbService.listWithUIDs<Employee>('employees')
      .then(employees => {
        this.employees = employees;
      });

    var today = new Date();
    var todayDay = today.getDate();
    var todayMonth = today.getMonth(); todayMonth++;
    var todayHour = today.getHours();

    this.dbService.listWithUIDs<importLog>('importLog')
      .then(imports => {
        this.imports = imports;
        if(this.imports.length > 0) {

          if(parseInt(this.imports[this.imports.length-1].date.split("-")[0]) < todayDay && todayHour >= 9)
            this.timeToImport = true;

          if(parseInt(this.imports[this.imports.length-1].date.split("-")[1]) < todayMonth && todayHour >= 9)
            this.timeToImport = true;

        } else {
          this.timeToImport = true;
        }
      });

    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        this.allCompanies = companies.filter(c => typeof(c.searchID) != "undefined");
        if (this.allCompanies.length > 0 && this.timeToImport) 
          this.importBiddings();
      });

    this.dbService.listWithUIDs<Bidding>('biddings')
      .then(biddings => {
        this.endingBiddings = biddings.filter(b => Date.now() > (b.limitDate - 100000) && b.status == 3);
        if (this.endingBiddings.length > 0 && this.timeToImport) 
          for(let i = 0; i < this.endingBiddings.length; i++)
            this.sendBiddingReminder(this.endingBiddings[i]);
      });

  }

  private importBiddings() {
    this.allCompanies.forEach(company => {

      this.companyEmployeeMail = this.employees.filter(e => e.companyUID === company.uid && e.isCompanyAdmin == true);
      this.companyEmployeeName = this.employees.filter(e => e.companyUID === company.uid && e.isCompanyAdmin == true);

      if(company.searchID != "" && company.searchID != " ") {
        console.log(company.name + ">" + this.companyEmployeeName);
        console.log(company.name + ">" + this.companyEmployeeMail);
        if(typeof(this.companyEmployeeMail) != "undefined" && typeof(this.companyEmployeeName) != "undefined") {
          console.log("Importando licitações para: " + company.name);
          const data = {
            id_pesquisa: company.searchID,
            user_email: this.companyEmployeeMail,
            user_name: this.companyEmployeeName,
            user_companyUID: company.uid,
            admin_sentUserUID: "zifyrF0xNmMK8QpaQ22Kp7yQPpK2",
          }
          this.http.post(this.ImportaLicitacoes, data).subscribe();
          console.log("Licitações importadas para: " + company.name);
        }
      }
    });
  }  

  sendBiddingReminder(bidding) {
    
    var emailsList = this.employees.filter(c => c.companyUID === bidding.companyUID);
    var toEmails = [];

    for(let i = 0; i < emailsList.length; i++) {
      toEmails.push({"email": emailsList[i].email});
    }

    const dataReminder = {
      toEmailVencimentoLicitacao: toEmails,
      toNameVencimentoLicitacao: this.companies.filter(c => c.uid === bidding.companyUID)[0].name,
      editalVencimentoLicitacao: bidding.edital,
      sendAtVencimentoLicitacao: bidding.limitDate
    }

    this.http.post(this.VencimentoLicitacao, dataReminder).subscribe();
    console.log("Licitações em vencimento enviadas.");

  }

  applyFilter(searchText) {
    this.searchText = searchText;
  }

  showItem(text: string) {
    return text.toLowerCase().includes(this.searchText.toLowerCase());
  }

  showUser() {
    return this.user = this.authService.getUser();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/header/header.component.ts